<template>
  <div
    class="relative dark:text-white m-auto max-w-[600px] py-12 w-full bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6"
    :class="context.wrapperClass"
  >
    <button
      class="absolute right-4 top-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 z-10"
      @click="context.close"
    >
      <IconX class="size-6" />
    </button>

    <div v-html="contentWithoutMailto" class="waf-error-content" />

    <div
      v-if="errorDetails"
      class="mt-6 p-4 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700"
    >
      <div class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
        Информация об ошибке:
      </div>
      <div class="space-y-2">
        <div v-if="errorDetails.errorId" class="flex justify-between text-sm">
          <span class="text-gray-600 dark:text-gray-400">ID ошибки:</span>
          <span
            class="font-mono text-gray-900 dark:text-white break-all text-right ml-4"
            >{{ errorDetails.errorId }}</span
          >
        </div>
        <div v-if="errorDetails.host" class="flex justify-between text-sm">
          <span class="text-gray-600 dark:text-gray-400">Хост:</span>
          <span class="font-mono text-gray-900 dark:text-white">{{
            errorDetails.host
          }}</span>
        </div>
        <div v-if="errorDetails.ip" class="flex justify-between text-sm">
          <span class="text-gray-600 dark:text-gray-400">IP адрес:</span>
          <span class="font-mono text-gray-900 dark:text-white">{{
            errorDetails.ip
          }}</span>
        </div>
      </div>

      <button
        class="mt-4 w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm font-medium"
        @click="reportError"
      >
        Сообщить об ошибке
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { IconX } from '@tabler/icons-vue'

const props = defineProps({
  context: {
    type: Object,
    default: () => ({}),
  },
  htmlContent: {
    type: String,
    default: '',
  },
})

const errorDetails = computed(() => {
  if (!props.htmlContent) return null

  const parser = new DOMParser()
  const doc = parser.parseFromString(props.htmlContent, 'text/html')

  const errorId = doc.querySelector('meta[name="ERROR_ID"]')?.content
  const host = doc.querySelector('meta[name="HOST"]')?.content
  const ip = doc.querySelector('meta[name="IP"]')?.content

  if (!errorId && !host && !ip) return null

  return {
    errorId,
    host,
    ip,
  }
})

const mailtoHref = computed(() => {
  if (!props.htmlContent) return ''

  const parser = new DOMParser()
  const doc = parser.parseFromString(props.htmlContent, 'text/html')

  const mailtoLink = doc.querySelector('a[href^="mailto:"]')
  return mailtoLink?.href || ''
})

const contentWithoutMailto = computed(() => {
  if (!props.htmlContent) return ''

  const parser = new DOMParser()
  const doc = parser.parseFromString(props.htmlContent, 'text/html')

  const mailtoLink = doc.querySelector('a[href^="mailto:"]')
  if (mailtoLink) {
    mailtoLink.remove()
  }

  return doc.body.innerHTML
})

function reportError() {
  if (mailtoHref.value) {
    window.location.href = mailtoHref.value
  }
}
</script>

<style scoped>
.waf-error-content :deep(.center) {
  position: static;
  transform: none;
  top: auto;
  left: auto;
}

.waf-error-content :deep(a) {
  @apply text-blue-600 dark:text-blue-400 hover:underline;
}

.waf-error-content :deep(h1) {
  @apply text-2xl font-bold mb-4;
}

.waf-error-content :deep(h2) {
  @apply text-lg font-bold mb-3;
}

.waf-error-content :deep(h3) {
  @apply font-bold mb-2;
}

.waf-error-content :deep(p) {
  @apply mb-3;
}
</style>
